document.addEventListener('DOMContentLoaded', function () {
    const timelineElements = document.querySelectorAll('.wp-block-knightowl-blocks-timeline');
    const initialDelay = 400;

    function createObserver(element) {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry, index) => {
                if (entry.isIntersecting) {
                    setTimeout(() => {
                        entry.target.classList.add('fade-in');
                    }, initialDelay + (index * 375));
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.5,
        });

        const timelineItems = element.querySelectorAll('.wp-block-knightowl-blocks-timeline-item');
        timelineItems.forEach(item => {
            observer.observe(item);
        });
    }

    timelineElements.forEach(element => {
        if (element.classList.contains('is-animation')) {
            createObserver(element);
        }
        const bottomCircle = document.createElement('div');
        bottomCircle.classList.add('bottom-circle');
        element.appendChild(bottomCircle);
    });
});
